export default {
   primary: '#037A8E',
   'primary-light': '#1ABEDB',
   secondary: '#424242',
   accent: '#82B1FF',
   error: '#FF3739',
   info: '#00D0BD',
   success: '#00D014',
   warning: '#FFB70F'
}